__turbopack_context__.v({
  "bbFade": "klB_1a_bbFade",
  "bbRise": "klB_1a_bbRise",
  "bbSheet": "klB_1a_bbSheet",
  "body": "klB_1a_body",
  "check": "klB_1a_check",
  "close": "klB_1a_close",
  "dialog": "klB_1a_dialog",
  "groupLabel": "klB_1a_groupLabel",
  "header": "klB_1a_header",
  "heading": "klB_1a_heading",
  "list": "klB_1a_list",
  "overlay": "klB_1a_overlay",
  "row": "klB_1a_row",
  "ship": "klB_1a_ship",
  "summary": "klB_1a_summary",
  "title": "klB_1a_title",
});
